import { el } from '../utils/dom.js';

/**
 * Donut chart minimalista, SVG vanilla. Recibe segmentos [{label, value, color}]
 * y muestra el centro con un valor (default = total).
 */
export function donut({ segments, centerValue, centerLabel, size = 140, thickness = 14 }) {
  const total = segments.reduce((a, s) => a + (s.value || 0), 0);
  const r = (size - thickness) / 2;
  const c = size / 2;
  const circumference = 2 * Math.PI * r;

  const NS = 'http://www.w3.org/2000/svg';
  const svg = document.createElementNS(NS, 'svg');
  svg.setAttribute('width', size);
  svg.setAttribute('height', size);
  svg.setAttribute('viewBox', `0 0 ${size} ${size}`);

  // Track
  const track = document.createElementNS(NS, 'circle');
  track.setAttribute('cx', c); track.setAttribute('cy', c); track.setAttribute('r', r);
  track.setAttribute('fill', 'none');
  track.setAttribute('stroke', 'var(--surface-2)');
  track.setAttribute('stroke-width', thickness);
  svg.appendChild(track);

  if (total > 0) {
    let offset = 0;
    for (const s of segments) {
      if (!s.value) continue;
      const len = (s.value / total) * circumference;
      const arc = document.createElementNS(NS, 'circle');
      arc.setAttribute('cx', c); arc.setAttribute('cy', c); arc.setAttribute('r', r);
      arc.setAttribute('fill', 'none');
      arc.setAttribute('stroke', s.color || 'var(--primary)');
      arc.setAttribute('stroke-width', thickness);
      arc.setAttribute('stroke-dasharray', `${len} ${circumference}`);
      arc.setAttribute('stroke-dashoffset', `${-offset}`);
      arc.setAttribute('stroke-linecap', 'round');
      svg.appendChild(arc);
      offset += len;
    }
  }

  return el('div', { class: 'donut', style: `width:${size}px;height:${size}px` },
    svg,
    el('div', { class: 'donut-label' },
      el('div', { class: 'v' }, String(centerValue ?? total)),
      centerLabel ? el('div', { class: 'l' }, centerLabel) : null,
    ),
  );
}

export function donutLegend(segments) {
  return el('div', { class: 'flex-col gap-2' },
    ...segments.filter((s) => s.value).map((s) =>
      el('div', { class: 'flex items-center gap-2 text-sm' },
        el('span', { style: `width:10px;height:10px;border-radius:50%;background:${s.color}` }),
        el('span', { class: 'flex-1 truncate' }, s.label),
        el('span', { class: 'text-bold' }, String(s.value)),
      )
    )
  );
}

/**
 * Sparkline: barras simples. Recibe array de numeros.
 */
export function sparkBars(values, { height = 48 } = {}) {
  const max = Math.max(1, ...values);
  return el('div', { class: 'spark', style: `height:${height}px` },
    ...values.map((v) =>
      el('div', { style: `height:${Math.max(4, (v / max) * 100)}%`, title: String(v) })
    )
  );
}
